module.exports = __webpack_public_path__ + "img/paraisoperdido.0546e3e1.jpg";